import UsersPage from './pages/Users.page';
import LocationsPage from './pages/Locations.page';
import DoorsPage from './pages/Doors.page';
import EmployeesPage from './pages/Employees.page';
import ServersPage from './pages/Servers.page';
import CamerasPage from './pages/Cameras.page';
import AgenciesPage from './pages/Agencies.page';
import FeatureFlagsPage from './pages/FeatureFlags.page';
import BtcAdminPage from './pages/Btc.page';

UsersPage.path = '/users';
LocationsPage.path = '/locations';
DoorsPage.path = '/doors';
EmployeesPage.path = '/employees';
ServersPage.path = '/servers';
CamerasPage.path = '/cameras';
BtcAdminPage.path = '/btc';
AgenciesPage.path = '/agencies';
FeatureFlagsPage.path = '/featureFlags'

export default {
  pages: {
    UsersPage,
    LocationsPage,
    DoorsPage,
    EmployeesPage,
    ServersPage,
    CamerasPage,
    BtcAdminPage,
    AgenciesPage,
    FeatureFlagsPage,
  }
};
